export const dataUnits: { [key: string]: string } = {
  //pitch data
  SpinRateRPM: "RPM",
  RelSpeedMPH: "MPH",
  yt_VertApprAngleDegrees: "Degrees",
  yt_RelHeightFeet: "Ft",
  PlateLocHeightFeet: "Ft",
  yt_PlateLocSideFeet: "Ft",
  ZoneSpeedMPH: "MPH",
  yt_RelSpeedMPH: "MPH",
  VertRelAngleDegrees: "Degrees",
  yt_OutOfPlaneDegrees: "Degrees",
  yt_VertRelAngleDegrees: "Degrees",
  VertApprAngleDegrees: "Degrees",
  HorzBreakInches: "In",
  yt_ZoneSpeedMPH: "MPH",
  RelHeightFeet: "Feet",
  RelSideFeet: "Feet",
  yt_FSRIPercent: "Percent",
  yt_ZoneTimeSeconds: "Seconds",
  VertBreakInches: "Inches",
  yt_HorzBreakInches: "",
  PlateLocSideFeet: "Feet",
  yt_HorzRelAngleDegrees: "",
  SpinAxisDegrees: "Degrees",
  HorzApprAngleDegrees: "Degrees",
  yt_HorzApprAngleDegrees: "Degrees",
  yt_InducedVertBreakInches: "",
  yt_PlateLocHeightFeet: "Feet",
  ExtensionFeet: "Feet",
  HorzRelAngleDegrees: "Degrees",
  yt_GyroSpinRPM: "RPM",
  plateEpochSeconds: "Seconds",
  InducedVertBreakInches: "Inches",
  yt_EffectiveSpinRPM: "RPM",
  Tilt: `OClock`,
  yt_RelSideFeet: "Feet",
  yt_SpinEfficiencyPercent: "Percent",
  ZoneTimeSeconds: "Seconds",
  //hit data
  BearingDegrees: "Degrees",
  DirectionDegrees: "Degrees",
  yt_HitLocationXFeet: "Feet",
  yt_GroundLocationXFeet: "Feet",
  yt_HitBreakTSeconds: "Seconds",
  yt_HitSpinComponentZ: "",
  yt_HitSpinComponentX: "",
  yt_HitSpinComponentY: "",
  yt_HitVelocityZMPH: "MPH",
  yt_GroundLocationYFeet: "Feet",
  exitEpochSeconds: "Seconds",
  yt_EffectiveBattingSpeedMPH: "MPH",
  AngleDegrees: "Degrees",
  yt_HitBreakYFeet: "Feet",
  HitSpinRateRPM: "RPM",
  HangTimeSeconds: "Seconds",
  yt_HitLocationZFeet: "Feet",
  ExitSpeedMPH: "MPH",
  yt_HitVelocityXMPH: "MPH",
  yt_HitBreakXFeet: "Feet",
  yt_HitLocationYFeet: "Feet",
  DistanceFeet: "Feet",
  yt_HitVelocityYMPH: "MPH",
};
